module.exports = __webpack_public_path__ + "static/media/promo.1e5754a7.png";